import React, { useContext } from 'react';
import styled from 'styled-components';
import context from '../../context/property';
import { Container, Row, Col } from 'react-bootstrap';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import { LeftOutlined, RightOutlined, WhatsAppOutlined } from '@ant-design/icons';
import { truncate, priceFormat } from '../../util';
import { Section } from '../../styled-components';
import { Site, Surface, Rooms, Bath, Parking } from '../../icons';

const ImageGalleryCustom = styled(ImageGallery)``;

const Image = styled.div`
  width: 100%;
  padding-top: 75%;
  position: relative;
  background-image: url("${props => props.src}");
  background-color: #000;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  ::before{
    content: "";
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: transparent;
    backdrop-filter: blur(6px);
  }
  ::after{
    content: "";
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: transparent;
    background-image: url("${props => props.src}");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center center;
  }  
`;

const IframeCont = styled.div`
  width: 100%;
  padding-top: 75%;
  position: relative;
`;

const Iframe = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  height:100%;
  width:100%;
  border: 0;
`;

const InteractiveCont = styled.div`
  margin:0px;
  padding:0px;
  @media(min-width:768px){
    min-height: 50vh;
  }
`;

const NavButton = styled.button`
  position: absolute;
  top: 50%;
  z-index: 500;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: ${props => props.theme.primaryColor};
  border: none;
  transition: 250ms ease;
  margin: 0 .5rem;
  color: #fff;
  cursor: pointer;
  &:hover{
    filter: brightness(1.1);
  }
`;

const NavButtonLeft = styled(NavButton)``;
const NavButtonRight = styled(NavButton)`
  right: 0;
`;

const InfoContainer = styled.div`
  width: 100%;
  padding-top: 93.33%;
  position: relative;
`;

const InfoContainerInner = styled.div` 
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
`;

const Code = styled.p`
  font-size: .8rem;
  text-transform: capitalize;
  font-weight: bold;
  font-family: 'Raleway', sans-serif !important;
  color: #6F7C99;
`;

const Title = styled.h2`
  color: ${props => props.theme.primaryColor};
  font-weight: 500;
  font-family: 'Raleway', sans-serif !important;

`;

const Price = styled(Title)`
  font-size: 2rem;
  color: #6F7C99;
  font-family: 'Raleway', sans-serif !important;
  span{
    font-size: 1rem;
    color: #9AAFC6;
  }
`;

const CharItem = styled.p`
  color: ${props => props.theme.primaryColor};
  display: flex;
  align-items: center;
  font-family: 'Raleway', sans-serif !important;
  margin: 0;
  margin-top: .5rem;
  span{
    color: #8A9AB0;
    margin-left: .3rem;
    font-size: .85rem;
  }
`;

const ShareButton = styled.button`
  background-color: #25D366;
  border: none;
  font-family: 'Raleway', sans-serif !important;
  color: #fff;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  font-size: 1rem;
  cursor: pointer;
  margin-top: 1rem;
  transition: 250ms ease;
  &:hover {
    opacity: 0.9;
  }
`;

const Centered = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

const InteractiveAsset = (item) => {
  return(
    <InteractiveCont>
      { item.provider ? (
          <IframeCont>
            <Iframe
              height="100%" width="100%"
              src={item.url}
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </IframeCont>
        ) : (
          <Image src={item.url} />
        )
      }
    </InteractiveCont>
  );
};

const getCategoryByCode = (title) => {
  if (typeof title !== 'string') return 'Categoría Desconocida';
  const map = {
    '01': 'Casa', '02': 'Departamento', '03': 'Oficina', '04': 'Sitio',
    '05': 'Local', '08': 'Industrial', '09': 'Agrícola', '10': 'Agrícola',
    '13': 'Agrícola', '14': 'Parcela', '15': 'Estacionamiento', '16': 'Terreno',
    '17': 'Bodega', '30': 'Negocio/Patentes/Derechos de llave',
    '31': 'Residencial/Pieza', '32': 'Hotel/Apart', '33': 'Complejo Turístico', '34': 'Departamento Amoblado'
  };
  const digits = title.match(/^[0-9]{1,2}/);
  const found = digits ? digits[0].padStart(2, '0') : null;
  return map[found] || 'Categoría Desconocida';
};

export default () => {
  const state = useContext(context);
  const {
    mainImage, operation, currency, images, videos, characteristics,
    title, ubication, value, valueUf, propertyType, code
  } = state;

  const propertyId = state.id || code;
  const gallery = [...images].map(item => ({
    thumbnail: item.provider ? item.interactive ? "/360-degrees.svg" : "/video.svg" : item.url,
    thumbnailClass: "thumbnail-custom",
    renderItem: () => <InteractiveAsset {...item} />, 
  }));

  const handleShare = () => {
    const shareUrl = `https://pmasesoriasinmobiliarias.cl/share/${propertyId}.html`;
    const message = `Mira esta propiedad en PM Asesorías Inmobiliarias: ${shareUrl}`;
    window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`, '_blank');
  };

  return(
    <Section height="50vh" first>
      <Container>
        <br /><br />
        <Row className="pt-3">
          <Col xs={12} md={7} className="d-none d-md-block">
            <ImageGalleryCustom
              items={gallery}
              showPlayButton={false}
              thumbnailPosition="left"
              renderLeftNav={(onClick, disabled)=> <NavButtonLeft onClick={onClick} disabled={disabled}><LeftOutlined /></NavButtonLeft>}
              renderRightNav={(onClick, disabled)=> <NavButtonRight onClick={onClick} disabled={disabled}><RightOutlined /></NavButtonRight>}
            />
          </Col>
          <Col xs={12} md={7} className="d-md-none">
            <ImageGalleryCustom
              items={gallery}
              showPlayButton={false}
              thumbnailPosition="bottom"
              renderLeftNav={(onClick, disabled)=> <NavButtonLeft onClick={onClick} disabled={disabled}><LeftOutlined /></NavButtonLeft>}
              renderRightNav={(onClick, disabled)=> <NavButtonRight onClick={onClick} disabled={disabled}><RightOutlined /></NavButtonRight>}
            />
          </Col>          
          <Col xs={12} md={5}>
            <InfoContainer>
              <InfoContainerInner>
                <div>
                  <Code>{operation.toLowerCase()} - COD: {code}</Code>
                  <Title>{getCategoryByCode(title)} {title.replace(/\d+/, '').trim()}</Title>
                </div>
                <div>
                  <Price>
                    {operation.toLowerCase() === "arriendo"
                      ? `${currency} $${priceFormat(value)}\n  `
                      : `UF ${valueUf}`
                    }<br />
                    <span>
                      {operation.toLowerCase() === "arriendo"
                        ? `UF ${valueUf}`
                        : `${currency} $${priceFormat(value)}`
                      }
                    </span>
                  </Price>
                </div>
                <Row>
                  <Col xs={6}>
                    <CharItem><Site /><span>{ubication.commune}</span></CharItem>
                  </Col>
                  {characteristics.filter(char => (
                    char.name === "Superficie total" ||
                    char.name === "Superficie útil" ||
                    char.name === "Dormitorios" ||
                    char.name === "Baños" ||
                    char.name === "Estacionamientos"
                  )).map((char, index) => (
                    <Col xs={6} key={index}>
                      <CharItem>
                        {(char.name === "Superficie total" || char.name === "Superficie útil") && <Surface /> ||
                         char.name === "Dormitorios" && <Rooms /> ||
                         char.name === "Baños" && <Bath /> ||
                         char.name === "Estacionamientos" && <Parking />}
                        <span>{char.name} {char.value} {(char.name.includes("Superficie")) && "mt2"}</span>
                      </CharItem>
                    </Col>
                  ))}
                </Row>
                <Centered>
                  <ShareButton onClick={handleShare}>
                    <WhatsAppOutlined style={{ marginRight: '0.5rem' }} />
                    Compartir por WhatsApp
                  </ShareButton>
                </Centered>
              </InfoContainerInner>
            </InfoContainer>
          </Col>
        </Row>
      </Container>
    </Section>
  );
};